import PropTypes from "prop-types";

import { useEffect, useState } from "react";

import iconsShare from "../../assets/svg/icons-share.svg";

import iconsBack from "../../assets/svg/icons-back.svg";

import { MAIN_WEBSITE_URL } from "../../constants/urls";

import { useTranslation } from "react-i18next";

import Container from "react-bootstrap/Container";

import Row from "react-bootstrap/Row";

import TabsCustom from "../../utils/TabsCustom";

import CuratedByRegHubContainer from "./CuratedByRegHubContainer";

import MySelection from "./MySelection";

import Tab3 from "../../stories/tabsExampleryComponents/Tab3";

import Loader from "../../utils/Loader";

import ErrorMessage from "../../utils/ErrorMessage";

import { connect, useDispatch } from "react-redux";

import { bindActionCreators } from "redux";

import { getCuratedRegHubTopics } from "../../actions/topicActions";

import Footer from "../FooterComponents/Footer";

import ReturnBackComponent from "../../utils/ReturnBackComponent";

import AlertMessage from "../../utils/AlertMessage";

import { isIPad13, isMobile } from "react-device-detect";
import { addArrayAction } from "../../actions/newsListActions";

const HomePageContainer = ({
  curatedRegHubTopicsAreLoading,
  curatedRegHubTopicsHaveLoadedWithError,
  getCuratedRegHubTopics,
  userToken,
  loggedIn,
  user,
}) => {
  const { t } = useTranslation(),
    tabsObject = {
      classNameOfTabContainer: isMobile
        ? "tabs-mobile tabs-main-container"
        : "tabs-main-container",
      classNameOfTabs: "main-tabs",
      defaultActiveKey: "curatedByRegHub",
      tabs: [
        {
          disabled: false,
          eventKey: "curatedByRegHub",
          tabClassName: "main-tab curatedByRegHubTab",
          title: t("curatedByRegHub"),
          component: <CuratedByRegHubContainer loggedIn={loggedIn} />,
        },
        {
          disabled: false,
          eventKey: "mySelection",
          tabClassName: "main-tab mySelection",
          title: t("mySelection"),
          component: <MySelection />,
        },
        {
          disabled: true,
          eventKey: "community",
          tabClassName: "main-tab community",
          title: t("community"),
          component: <Tab3 />,
        },
      ],
    },
    [isShared, setIsShared] = useState(),
    [selectedTab, setSelectedTab] = useState("curatedByRegHub"),
    [isOrientationChanged, setIsOrientationChanged] = useState(false);
  const dispatch = useDispatch();

  function onShareClick() {
    setIsShared(true);

    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(window.location.href);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  }

  function onShareClose() {
    setIsShared(false);
  }

  useEffect(() => {
    if (userToken) {
      getCuratedRegHubTopics(userToken, user.USER_EMAIL);
      dispatch(addArrayAction([]));
    }

    if (isIPad13 && !loggedIn) {
      window.addEventListener("orientationchange", function () {
        setIsOrientationChanged(true);

        setTimeout(function () {
          setIsOrientationChanged(false);
        }, 1000);
      });
    }
  }, [getCuratedRegHubTopics, userToken, user, loggedIn, dispatch]);

  return (
    <Container expand="lg" className="home-page-container">
      <ReturnBackComponent
        url={MAIN_WEBSITE_URL}
        text={t("mainWebSite")}
        image={iconsBack}
      />
      <Row className="main-heading-row">
        <span className={"heading fs-21"}>{t("topics")}</span>
      </Row>
      <Row className={loggedIn ? "subline-heading-row" : "display-none"}>
        <span className="topic-subheading-right-options home-page fs-14">
          <span
            onClick={() => onShareClick()}
            className="topic-subheading-option topic-subheading-options-logged-in cursor-pointer"
          >
            <img
              width={"24px"}
              height={"24px"}
              src={iconsShare}
              className="topic-subheading-option-icon"
            />
            <span className="topic-subheading-option-label">{t("share")}</span>
          </span>
        </span>
      </Row>
      <hr className="horizontal-ruler" />
      {!isOrientationChanged &&
      !curatedRegHubTopicsAreLoading &&
      !curatedRegHubTopicsHaveLoadedWithError ? (
        <TabsCustom
          classNameOfTabs={tabsObject.classNameOfTabs}
          defaultActiveKey={tabsObject.defaultActiveKey}
          tabs={tabsObject.tabs}
          classNameOfTabContainer={tabsObject.classNameOfTabContainer}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      ) : (
        <div className="display-none" />
      )}
      {curatedRegHubTopicsAreLoading || isOrientationChanged ? (
        <Loader />
      ) : (
        <div className="display-none" />
      )}
      {curatedRegHubTopicsHaveLoadedWithError ? (
        <ErrorMessage />
      ) : (
        <div className="display-none" />
      )}
      {isShared ? (
        <AlertMessage
          variant="success"
          onClose={() => onShareClose()}
          successHeading={t("success")}
          mainMessage={t("copyURLMessage")}
        />
      ) : (
        <div className="display-none" />
      )}
      <Footer />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    curatedRegHubTopicsAreLoading:
      state.topicReducer.curatedRegHubTopicsAreLoading,
    curatedRegHubTopicsHaveLoadedWithError:
      state.topicReducer.curatedRegHubTopicsHaveLoadedWithError,
    userToken: state.configReducer.userToken,
    loggedIn: state.userReducer.loggedIn,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCuratedRegHubTopics: bindActionCreators(
      getCuratedRegHubTopics,
      dispatch
    ),
  };
};

HomePageContainer.propTypes = {
  curatedRegHubTopicsAreLoading: PropTypes.bool.isRequired,
  curatedRegHubTopicsHaveLoadedWithError: PropTypes.bool.isRequired,
  getCuratedRegHubTopics: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
  }).isRequired,
};

HomePageContainer.defaultProps = {
  curatedRegHubTopicsAreLoading: false,
  curatedRegHubTopicsHaveLoadedWithError: false,
  getCuratedRegHubTopics: () => {},
  userToken: "",
  loggedIn: false,
  user: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
